var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ul",
        { staticClass: "day_info_list" },
        _vm._l(_vm.checkBudget.planDayList, function (item, index) {
          return _c(
            "li",
            { key: index, attrs: { id: "planDayBudget" + item.planDay } },
            [
              _c("div", { staticClass: "time_box" }, [
                _c("span", { staticClass: "day_icon" }, [
                  _vm._v("D" + _vm._s(item.planDay)),
                ]),
                _c("div", { staticClass: "time" }, [
                  _vm._v(_vm._s(_vm.dateFormatYMD(item.planDate, "-"))),
                ]),
                _c("div", { staticStyle: { "margin-right": "0.1rem" } }, [
                  _vm._v(_vm._s(_vm.getWeekDate(item.planDate))),
                ]),
                _c(
                  "div",
                  { staticClass: "place" },
                  _vm._l(item.cityList, function (city, ii) {
                    return _c("span", { key: ii }, [
                      _vm._v(_vm._s(city.cityName)),
                      ii != item.cityList.length - 1
                        ? _c("span", [_vm._v("-")])
                        : _vm._e(),
                    ])
                  }),
                  0
                ),
              ]),
              _c(
                "div",
                { staticClass: "container" },
                _vm._l(item.budgetDetails, function (budget, ii) {
                  return _c(
                    "div",
                    { key: ii, attrs: { id: "budget" + budget.id } },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                budget.isShow &&
                                (_vm.chooseStockTypes.indexOf(budget.state) !=
                                  -1 ||
                                  (budget.state == 11 &&
                                    _vm.chooseStockTypes.length ==
                                      _vm.allStockTypes.length)),
                              expression:
                                "budget.isShow&&(chooseStockTypes.indexOf(budget.state) != -1 || (budget.state == 11 && chooseStockTypes.length == allStockTypes.length))",
                            },
                          ],
                          staticClass: "body_info",
                          style:
                            budget.orderSize > 0 ? "margin-top: 0.25rem;" : "",
                        },
                        [
                          budget.state == 11
                            ? _c("div", [
                                _c(
                                  "div",
                                  { staticStyle: { "padding-top": "0.05rem" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "editimg",
                                        on: { click: _vm.openChangeTime },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-edit-outline",
                                          staticStyle: {
                                            color: "white",
                                            "font-size": "0.15rem",
                                            left: "0.04rem",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-left": "0.26rem",
                                        },
                                      },
                                      [_vm._v(_vm._s(budget.resourceNameCn))]
                                    ),
                                    budget.stayDate != item.planDate
                                      ? _c("span", { staticClass: "time" }, [
                                          _vm._v(
                                            "  " +
                                              _vm._s(
                                                _vm.dateFormatHM(
                                                  budget.stayDate
                                                )
                                              ) +
                                              "-" +
                                              _vm._s(
                                                _vm.dateFormatHM(
                                                  budget.endStayDate
                                                )
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-left": "0.1rem",
                                        },
                                      },
                                      [_vm._v(_vm._s(budget.remark))]
                                    ),
                                  ]
                                ),
                              ])
                            : _c("div", { staticStyle: { display: "flex" } }, [
                                _c("div", { staticClass: "info_left" }, [
                                  _c("div", { staticClass: "price_img_box" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "top_price",
                                        style:
                                          budget.status === 1
                                            ? "background:#888483"
                                            : "",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openDetailDialog(budget)
                                          },
                                        },
                                      },
                                      [
                                        budget.status === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: { color: "white" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openProductMoveDialog.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("已失效")]
                                            )
                                          : budget.productType == 7
                                          ? _c("span", [_vm._v("外观")])
                                          : budget.productType == 8
                                          ? _c("span", [_vm._v("免费")])
                                          : _c("div", [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "z-index": "1",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.showCostPrice
                                                          ? Number(
                                                              budget.totalPrice.toFixed(
                                                                2
                                                              )
                                                            )
                                                          : Number(
                                                              budget.saleTotalPrice.toFixed(
                                                                2
                                                              )
                                                            )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "currency" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(budget.currency)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              !_vm.linkProductFlag
                                                ? _c(
                                                    "div",
                                                    { staticClass: "editimg" },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-edit-outline",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.planProductShowStatus,
                                            expression: "planProductShowStatus",
                                          },
                                        ],
                                        staticClass: "bottom_img",
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: budget.imageUrl,
                                            alt: "",
                                            width: "100%",
                                          },
                                        }),
                                        budget.status === 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "image-iop",
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [_vm._v("点击调整 ")]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "info_container" }, [
                                    _c(
                                      "div",
                                      { staticClass: "resource_name" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              budget.resourceNameCn != ""
                                                ? budget.resourceNameCn
                                                : budget.resourceNameEn
                                            ) + " "
                                          ),
                                        ]),
                                        budget.star
                                          ? _c(
                                              "span",
                                              _vm._l(
                                                budget.star,
                                                function (item1) {
                                                  return _c("i", {
                                                    key: item1,
                                                    staticClass:
                                                      "el-icon-star-on",
                                                  })
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                        (budget.stayDate != item.planDate ||
                                          budget.endStayDate !=
                                            item.planDate) &&
                                        budget.state != 15
                                          ? _c(
                                              "span",
                                              { staticClass: "time" },
                                              [
                                                _vm._v("  "),
                                                budget.stayDate !=
                                                  item.planDate &&
                                                budget.endStayDate !=
                                                  item.planDate
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.dateFormatHM(
                                                            budget.stayDate
                                                          )
                                                        ) +
                                                          "-" +
                                                          _vm._s(
                                                            _vm.dateFormatHM(
                                                              budget.endStayDate
                                                            )
                                                          )
                                                      ),
                                                    ])
                                                  : budget.stayDate !=
                                                      item.planDate &&
                                                    budget.endStayDate ==
                                                      item.planDate
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.dateFormatHM(
                                                            budget.stayDate
                                                          )
                                                        ) + "出发"
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.dateFormatHM(
                                                            budget.endStayDate
                                                          )
                                                        ) + "结束"
                                                      ),
                                                    ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        budget.linkBudgetIds &&
                                        budget.linkBudgetIds.length > 0
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-link",
                                                  {
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.selectLinkProduct(
                                                          budget
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" 查看关联产品 ")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.planProductShowStatus,
                                            expression: "planProductShowStatus",
                                          },
                                        ],
                                      },
                                      [
                                        budget.inquiryId != ""
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "icon_box1",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getInquiryDetail(
                                                      budget
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                budget.details &&
                                                budget.details.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                          "margin-right":
                                                            "0.1rem",
                                                        },
                                                      },
                                                      [
                                                        budget.details[0]
                                                          .isInquirySend == 1
                                                          ? _c("div", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "已发送给客户"
                                                                  ),
                                                                ]
                                                              ),
                                                            ])
                                                          : _c("div", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "暂未发送给客户"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  { staticClass: "icon-xun" },
                                                  [
                                                    _vm._v(
                                                      " 询单号 " +
                                                        _vm._s(
                                                          budget.inquiryId
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _vm._m(0, true),
                                                budget.optionTime
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "icon-xun",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.getTimeNumber(
                                                                budget.optionTime
                                                              ) != "已失效"
                                                                ? _vm.getTimeNumber(
                                                                    budget.optionTime
                                                                  ) +
                                                                    "后报价失效"
                                                                : _vm.getTimeNumber(
                                                                    budget.optionTime
                                                                  )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                budget.optionTime
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "icon-right",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _vm._v("限时购"),
                                                        ]),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                        budget.state == 15
                                          ? _c(
                                              "div",
                                              { staticClass: "position_box" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color: "#02a0c6",
                                                      "font-size": "0.13rem",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          budget.resourceDetail
                                                            .startPortName
                                                        ) +
                                                        "-" +
                                                        _vm._s(
                                                          budget.resourceDetail
                                                            .endPortName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        budget.state == 15
                                          ? _c(
                                              "div",
                                              { staticClass: "position_box" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "0.13rem",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 参考" +
                                                        _vm._s(
                                                          budget.resourceDetail
                                                            .flightNumber
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          budget.resourceDetail
                                                            .startDate
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          budget.resourceDetail
                                                            .startTime
                                                        ) +
                                                        "-" +
                                                        _vm._s(
                                                          budget.resourceDetail
                                                            .endTime
                                                        ) +
                                                        _vm._s(
                                                          budget.resourceDetail
                                                            .endTimeStr
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        budget.labels &&
                                        budget.labels.length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "icon_box" },
                                              _vm._l(
                                                budget.labels,
                                                function (label, labelIndex) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: labelIndex,
                                                      staticClass: "icon",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(label) + " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                        budget.addressCn &&
                                        budget.addressCn != ""
                                          ? _c(
                                              "div",
                                              { staticClass: "position_box" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-location",
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(budget.addressCn) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        budget.introduce &&
                                        budget.introduce != ""
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "position_box",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(budget.introduce)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      placement: "top",
                                                      "popper-class":
                                                        "addressBoxTip",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          slot: "content",
                                                        },
                                                        slot: "content",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            budget.introduce
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c("span", [
                                                      _vm._v("更多"),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "info_price_box" },
                                          [
                                            _c(
                                              "span",
                                              _vm._l(
                                                budget.details,
                                                function (detail, dindex) {
                                                  return _c(
                                                    "p",
                                                    {
                                                      key: dindex,
                                                      staticStyle: {
                                                        "margin-left":
                                                          "0.08rem",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                detail.isShow,
                                                              expression:
                                                                "detail.isShow",
                                                            },
                                                          ],
                                                        },
                                                        [
                                                          detail.stockDetail
                                                            .budgetType &&
                                                          detail.stockDetail
                                                            .budgetType != ""
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "desc",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      detail
                                                                        .stockDetail
                                                                        .budgetType
                                                                    ) + "  "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          detail.stockDetail
                                                            .priceList &&
                                                          detail.stockDetail
                                                            .priceList.length >
                                                            0 &&
                                                          detail.stockDetail
                                                            .priceList[0]
                                                            .timeDesc &&
                                                          detail.stockDetail
                                                            .priceList[0]
                                                            .timeDesc != ""
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "desc",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      detail
                                                                        .stockDetail
                                                                        .priceList[0]
                                                                        .timeDesc
                                                                    ) + "  "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                detail.productName
                                                              ) + "  "
                                                            ),
                                                          ]),
                                                          detail.stockDetail
                                                            .productDesc
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "desc",
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        placement:
                                                                          "top",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              slot: "content",
                                                                            },
                                                                          slot: "content",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              detail
                                                                                .stockDetail
                                                                                .productDesc
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              detail
                                                                                .stockDetail
                                                                                .productDesc
                                                                                .length >
                                                                                20
                                                                                ? detail.stockDetail.productDesc.slice(
                                                                                    0,
                                                                                    20
                                                                                  ) +
                                                                                    "..."
                                                                                : detail
                                                                                    .stockDetail
                                                                                    .productDesc
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          detail.stockDetail
                                                            .stockDesc
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "desc",
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        placement:
                                                                          "top",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              slot: "content",
                                                                            },
                                                                          slot: "content",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              detail
                                                                                .stockDetail
                                                                                .stockDesc
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              detail
                                                                                .stockDetail
                                                                                .stockDesc
                                                                                .length >
                                                                                20
                                                                                ? detail.stockDetail.stockDesc.slice(
                                                                                    0,
                                                                                    20
                                                                                  ) +
                                                                                    "..."
                                                                                : detail
                                                                                    .stockDetail
                                                                                    .stockDesc
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          detail.stockDetail &&
                                                          detail.stockDetail
                                                            .cancelType
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "desc",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        detail
                                                                          .stockDetail
                                                                          .cancelType ==
                                                                          1
                                                                          ? "不可取消"
                                                                          : detail
                                                                              .stockDetail
                                                                              .cancelType ==
                                                                            5
                                                                          ? "随时退"
                                                                          : detail
                                                                              .stockDetail
                                                                              .cancelType ==
                                                                            6
                                                                          ? "过期退"
                                                                          : "有条件退"
                                                                      ) +
                                                                      "   "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.showCostPrice
                                                                    ? detail.stockPrice
                                                                    : detail.ratio
                                                                ) +
                                                                _vm._s(
                                                                  detail.currency
                                                                ) +
                                                                " "
                                                            ),
                                                            detail.stockDetail
                                                              .priceList &&
                                                            detail.stockDetail
                                                              .priceList
                                                              .length > 0
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        detail
                                                                          .stockDetail
                                                                          .priceList[0]
                                                                          .priceCompany
                                                                      ) +
                                                                      "/" +
                                                                      _vm._s(
                                                                        detail
                                                                          .stockDetail
                                                                          .priceList[0]
                                                                          .useTime
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticStyle: {
                                                                  color:
                                                                    "#8E2B0B",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    detail.stockNumber
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            detail.stockDetail
                                                              .priceList &&
                                                            detail.stockDetail
                                                              .priceList
                                                              .length > 0
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        detail
                                                                          .stockDetail
                                                                          .priceList[0]
                                                                          .priceCompany
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            detail.stockDetail
                                                              .recommendation
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "desc",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        detail
                                                                          .stockDetail
                                                                          .recommendation
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    budget
                                                                      .details
                                                                      .length -
                                                                      1 ==
                                                                    dindex,
                                                                  expression:
                                                                    "(budget.details.length-1)==dindex",
                                                                },
                                                              ],
                                                            },
                                                            [
                                                              budget.details
                                                                .length != 0 &&
                                                              !_vm.linkProductFlag
                                                                ? _c("i", {
                                                                    staticClass:
                                                                      "el-icon-edit-outline",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "0.21rem",
                                                                        color:
                                                                          "#BFBFBF",
                                                                      },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.openDetailDialog(
                                                                            budget,
                                                                            1
                                                                          )
                                                                        },
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                              budget.details
                                                                .length != 0 &&
                                                              !_vm.linkProductFlag
                                                                ? _c("img", {
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "0.21rem",
                                                                        "vertical-align":
                                                                          "top",
                                                                      },
                                                                    attrs: {
                                                                      src: require("../../../../assets/svg/add-grey.svg"),
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.addStockMore(
                                                                            budget
                                                                          )
                                                                        },
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.planProductShowStatus,
                                        expression: "planProductShowStatus",
                                      },
                                    ],
                                    staticClass: "info_right",
                                    style:
                                      budget.oldPlanId && budget.oldPlanId != ""
                                        ? "top: -15px;"
                                        : "",
                                  },
                                  [
                                    budget.oldPlanId && budget.oldPlanId != ""
                                      ? _c(
                                          "div",
                                          { staticClass: "info_right_top" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  padding: "0px 10px 0px 10px",
                                                },
                                              },
                                              [
                                                _vm._v(" 来自于 "),
                                                _c("img", {
                                                  staticStyle: {
                                                    width: "19px",
                                                    height: "19px",
                                                    "margin-top": "4px",
                                                  },
                                                  attrs: {
                                                    src: budget.oldPlanInfo
                                                      .userImageUrl,
                                                  },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      budget.oldPlanInfo
                                                        .userName
                                                    ) +
                                                    "  编号" +
                                                    _vm._s(budget.oldPlanId) +
                                                    "的方案 "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: budget.showOprationButton,
                                            expression:
                                              "budget.showOprationButton",
                                          },
                                        ],
                                        staticClass: "info_right_botton",
                                      },
                                      [
                                        !_vm.linkProductFlag
                                          ? _c(
                                              "div",
                                              { staticClass: "right_button4" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "right_button5",
                                                    on: {
                                                      click: _vm.openChangeTime,
                                                    },
                                                  },
                                                  [
                                                    _c("svg-icon", {
                                                      attrs: {
                                                        iconClass: "clock",
                                                        systemColor: "#2290AA",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "right_button5",
                                                  },
                                                  [
                                                    _c("svg-icon", {
                                                      attrs: {
                                                        iconClass: "share",
                                                        systemColor: "#2290AA",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "right_button4" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "right_button5",
                                                style:
                                                  budget.productType != 7 &&
                                                  budget.productType != 8
                                                    ? ""
                                                    : "background: #e4e4e4;color: #888483;",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handlerBookClick(
                                                      budget
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "800",
                                                    },
                                                  },
                                                  [_vm._v("订")]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "right_button5",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteBudget(
                                                      budget
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    iconClass:
                                                      "if-ui-delete2-white",
                                                    systemColor: "#02A0C6",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        !_vm.linkProductFlag
                                          ? _c(
                                              "div",
                                              { staticClass: "right_button4" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "right_button5",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handlerInquiry(
                                                          budget
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-weight": "800",
                                                        },
                                                      },
                                                      [_vm._v("询")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "right_button5",
                                                    staticStyle: {
                                                      "margin-right": "0",
                                                    },
                                                    on: {
                                                      click: _vm.openTweetImage,
                                                    },
                                                  },
                                                  [
                                                    _c("svg-icon", {
                                                      attrs: {
                                                        iconClass:
                                                          "riFill-heart-fill-white",
                                                        systemColor: "#71CADF",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: budget.orderSize > 0,
                                  expression: "budget.orderSize>0",
                                },
                              ],
                              staticClass: "rightOrderDiv",
                              on: {
                                click: function ($event) {
                                  return _vm.openDetailDialog(budget, 1)
                                },
                              },
                            },
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "bottom",
                                    trigger: "hover",
                                    width: "220",
                                  },
                                },
                                [
                                  budget.orderStatusArr &&
                                  budget.orderStatusArr.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          budget.orderStatusArr[0].orderNumber >
                                          0
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "info_right_orderNumber",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "订单号" +
                                                        _vm._s(
                                                          budget.orderStatusArr[0].orderNumber.slice(
                                                            0,
                                                            10
                                                          )
                                                        ) +
                                                        "..."
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v("   "),
                                          _c(
                                            "span",
                                            { staticClass: "profit" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    budget.orderStatusArr[0]
                                                      .status
                                                  ) +
                                                  "   "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("div", { staticClass: "clsStatus" }, [
                                    budget.orderStatusArr &&
                                    budget.orderStatusArr.length > 0
                                      ? _c(
                                          "div",
                                          _vm._l(
                                            budget.orderStatusArr,
                                            function (value, index1) {
                                              return _c(
                                                "p",
                                                {
                                                  key: index1,
                                                  staticClass: "three",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "three1" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          value.orderNumber
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v("  "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        color: "#DB4E1A",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(value.status)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        }),
        0
      ),
      _c("change-plan-time-dialog", {
        ref: "changePlanTime",
        attrs: { checkBudgetDetail: _vm.checkBudget },
      }),
      _c("product-move", { ref: "productMove" }),
      _c("budget-single-detail-dialog", {
        ref: "budgetSingleDetailDialog",
        attrs: { checkBudget: _vm.checkBudget },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "orderDetailDialog",
          attrs: {
            visible: _vm.orderDetailVisible,
            "append-to-body": "",
            "destroy-on-close": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderDetailVisible = $event
            },
          },
        },
        [
          _c("static-table", {
            attrs: {
              loading: _vm.loading,
              tableData: _vm.tableData,
              dataType: _vm.dataType,
            },
            on: { updateList: _vm.updateList },
          }),
        ],
        1
      ),
      _c("createPreOrder", { ref: "orderPre" }),
      _c("tweet-image-dialog", { ref: "tweetImage" }),
      _c("PlanInquiryDetail", { ref: "planInquiryDetail" }),
      _c(
        "el-dialog",
        {
          staticClass: "deleteDialog",
          attrs: {
            modal: false,
            "show-close": false,
            visible: _vm.deleteInfoVisible,
            width: "17%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteInfoVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "popover" }, [
            _c("p", [
              _vm._v(
                "注意：此操作将会永久删除该数据不可恢复，您确定要删除吗？"
              ),
            ]),
            _c(
              "div",
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: "1" },
                    model: {
                      value: _vm.deleteRadio,
                      callback: function ($$v) {
                        _vm.deleteRadio = $$v
                      },
                      expression: "deleteRadio",
                    },
                  },
                  [
                    _vm._v("仅删除 "),
                    _c("span", { staticStyle: { "font-weight": "bolder" } }, [
                      _vm._v("当天"),
                    ]),
                    _vm._v(" 的资源 "),
                  ]
                ),
                _c(
                  "el-radio",
                  {
                    attrs: { label: "2" },
                    model: {
                      value: _vm.deleteRadio,
                      callback: function ($$v) {
                        _vm.deleteRadio = $$v
                      },
                      expression: "deleteRadio",
                    },
                  },
                  [
                    _vm._v("删除 "),
                    _c("span", { staticStyle: { "font-weight": "bolder" } }, [
                      _vm._v("行程内"),
                    ]),
                    _vm._v(" 的所有该资源 "),
                  ]
                ),
              ],
              1
            ),
            _c(
              "span",
              { staticClass: "dialog-footer" },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.deleteInfoVisible = false
                      },
                    },
                  },
                  [_vm._v("取 消")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteInfoSure()
                      },
                    },
                  },
                  [_vm._v("确 定")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-right" }, [
      _c("div", [_vm._v("专属")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }